<template>
  <div
    class="loginPage"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="title">
      <div class="logo flex-rowc">
        <!-- <el-image
          style="width: 253px; height: 28px"
          :src="require('@/assets/images/login_logo1.png')"
        ></el-image> -->
        <!-- <el-image
          style="width: 101px; height: 28px"
          :src="require('@/assets/images/login_logo2.png')"
        ></el-image> -->
      </div>
      <div class="logo2 flex-rowc">
        <el-image
          style="width: 552px; height: 60px"
          :src="require('@/assets/images/login_logo3.png')"
        ></el-image>
      </div>
      <div class="txt flex-rowc">
        <!-- <h1>用户登录</h1> -->
        <span class="left">[</span> SPR Plus
        跨境新零售&供销存一体化管理服务平台 <span class="right">]</span>
      </div>
    </div>
    <div class="form_wrap">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="95px"
        label-position="left"
        class="demo-ruleForm"
      >
        <el-form-item label="用户名" prop="loginname">
          <el-input
            v-model="ruleForm.loginname"
            placeholder="请输入4~20位用户名"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="loginpwd">
          <el-input
            v-model="ruleForm.loginpwd"
            placeholder="请输入6~18位密码"
          ></el-input>
        </el-form-item>
        <div class="verify_wrap">
          <div class="verify-code flex-rowc">
            <canvas
              id="canvas"
              width="100"
              height="43"
              @click="changeCode()"
              style="border: 1px solid #ccc; border-radius: 5px"
            ></canvas>
            <div class="verify-code-change" @click="changeCode()">
              <el-link style="color: #5c5959" type="info" :underline="false"
                >看不清，</el-link
              ><el-link type="primary" :underline="false">换一张</el-link>
            </div>
          </div>
          <div class="verify-input flex-rowc">
            <!-- <span style="color: #EA3C2A; font-weight: bold;"></span> -->
            <el-form-item label="验证码" prop="verifyCode" label-width="70px">
              <el-input
                v-model="ruleForm.verifyCode"
                placeholder="请输入验证码"
                @keyup.enter.native="submitForm('ruleForm')"
              ></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="flex-rowc">
          <div
            class="primary-button"
            @click="submitForm('ruleForm')"
            v-loading.fullscreen.lock="fullscreenLoading"
          >
            登录
          </div>
        </div>
        <div class="tip flex-rowc">
          忘记密码？
          <p @click="handleGo(1)">找回密码→</p>
        </div>
        <div class="tip flex-rowc">
          还没有账户，
          <p @click="handleGo(2)">马上预约注册→</p>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import { userLogin, getUserInfo } from "../api/api";
export default {
  name: "login",
  data() {
    var validatorCode = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入验证码"));
      } else if (value != this.numCode.join("")) {
        callback(new Error("验证码不正确"));
      } else {
        callback();
      }
    };
    return {
      fullscreenLoading: false,
      numCode: "",

      ruleForm: {
        usertype: "个人用户",
        loginname: "",
        loginpwd: "",
        question: "",
        answer: "",
        verifyCode: "",
      },
      rules: {
        loginname: [
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 4, max: 20, message: "请输入4~20位用户名", trigger: "blur" },
        ],
        loginpwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 18, message: "请输入6~18位密码", trigger: "blur" },
        ],
        verifyCode: [
          { required: true, validator: validatorCode, trigger: "blur" },
        ],
      },

      loading: false,
      isShow: false,
    };
  },
  created() {
    console.log();
    // setTimeout(() => {
    //   location.href='http://192.168.31.206:8888/#/qyLogin/1'
    // },500)
    
  },
  mounted() {
    this.drawCode([]);
  },
  methods: {
    submitForm(formName) {
      this.$store.commit("updateLoginType", 0);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true;
          let { usertype, loginname, loginpwd, question, answer } =
            this.ruleForm;
          let params = {
            usertype,
            loginname,
            loginpwd,
            question,
            answer,
          };
          this.userSubmit(params);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 登录接口
    userSubmit(params) {
      userLogin(params).then((res) => {
        if (res.result) {
          let message = this.$message.success(res.message);
          this.$store.commit("updateOpenid", res.code);
          this.fullscreenLoading = false;
          this.getUserInfo(res.code);
          setTimeout(() => {
            message.close();
            // this.$router.push("/home");
          }, 1500);
        } else {
          this.$message.error(res.message || "接口失效，请稍后～");
          this.fullscreenLoading = false;
        }
      });
    },

    getUserInfo(openid) {
      getUserInfo({ openid: openid }).then((res) => {
        if (Object.keys(res).length > 0) {
          this.$store.commit("updateUserInfo", res);
          this.$store.commit("setUserLoginType", 0);
          if (res.mobile) {
            setTimeout(() => {
              this.$router.push("/home");
            }, 1500);
          } else {
            setTimeout(() => {
              // this.$router.push("/guide");
            }, 1500);
          }
        }
      });
    },

    // 验证码
    changeCode() {
      this.drawCode([]);
    },
    drawCode(show_num) {
      var canvas_width = document.getElementById("canvas").clientWidth;
      var canvas_height = document.getElementById("canvas").clientHeight;
      var canvas = document.getElementById("canvas"); //获取到canvas的对象，演员
      var context = canvas.getContext("2d"); //获取到canvas画图的环境，演员表演的舞台
      canvas.width = canvas_width;
      canvas.height = canvas_height;
      var sCode = "0,1,2,3,4,5,6,7,8,9";
      // var sCode = "A,B,C,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,W,X,Y,Z,1,2,3,4,5,6,7,8,9,0,q,w,e,r,t,y,u,i,o,p,a,s,d,f,g,h,j,k,l,z,x,c,v,b,n,m";
      var aCode = sCode.split(",");
      var aLength = aCode.length; //获取到数组的长度
      let newNum = [];
      for (var i = 0; i <= 3; i++) {
        var j = Math.floor(Math.random() * aLength); //获取到随机的索引值
        var deg = (Math.random() * 30 * Math.PI) / 180; //产生0~30之间的随机弧度
        var txt = aCode[j]; //得到随机的一个内容
        show_num[i] = txt;
        var x = 10 + i * 20; //文字在canvas上的x坐标
        var y = 20 + Math.random() * 8; //文字在canvas上的y坐标
        context.font = "bold 23px 微软雅黑";

        context.translate(x, y);
        context.rotate(deg);

        context.fillStyle = this.randomColor();
        context.fillText(txt, 0, 0);

        context.rotate(-deg);
        context.translate(-x, -y);
        newNum.push(show_num[i]);
      }
      this.numCode = newNum;
    },
    randomColor() {
      //得到随机的颜色值
      var r = Math.floor(Math.random() * 256);
      var g = Math.floor(Math.random() * 256);
      var b = Math.floor(Math.random() * 256);
      return "rgb(" + r + "," + g + "," + b + ")";
    },

    handleGo(type) {
      if (type == 1) {
        this.$router.push("/password");
      } else if (type == 2) {
        this.$router.push("/register");
      }
    },
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll); //销毁滚动事件
  },
};
</script>
<style lang="less" scoped>
.loginPage {
  padding: 0 60px;
  .title {
    padding: 35px 0 26px;
    border-bottom: 6px solid #6e5d87;
    .logo2 {
      margin: 18px 0;
    }
    .txt {
      font-size: 18px;
      color: #000000;
      position: relative;
      span {
        &.left {
          margin-right: 15px;
        }
        &.right {
          margin-left: 15px;
        }
      }
      h1 {
        position: absolute;
        left: 0;
        font-size: 20px;
        color: #444444;
      }
    }
  }
  .form_wrap {
    height: 62vh;
    overflow-y: scroll;
    width: 780px;
    margin: 60px auto 0;
    &::-webkit-scrollbar {
      display: none;
    }
    .verify_wrap {
      margin-top: 35px;
      margin-bottom: 25px;
      .verify-code {
        margin-bottom: 20px;
        .verify-code-change {
          margin-left: 20px;
        }
      }
    }
    .primary-button-plain {
      margin-left: 40px;
      .icon-erweima {
        font-size: 22px;
        margin-right: 5px;
      }
    }
    .tip {
      font-size: 16px;
      color: #828282;
      margin: 35px auto;
      p {
        color: #ff0012;
        cursor: pointer;
      }
    }
  }
  .custom_dialog {
    .custom_wrap {
      width: 500px;
      .main {
        margin: 10px 0 40px;
      }
    }
  }
}
</style>